import $ from 'jquery';
import { protectRoute, commonMiddleware } from '../middleware';
import { initHomeExperience } from '~src/home';
import { initSidebarProfile } from '../../sidebar-profile';

const resetProfileMenuState = () => {
  $('#dashboard-sidebar-profile-menu')
    .removeClass('is-open')
    .attr('aria-hidden', 'true');
  $('#dashboard-sidebar-profile-trigger').attr('aria-expanded', 'false');
  $('body').removeClass('sidebar-context-locked');
};

export const homeRoute = async () => {
  document.title = 'Giotto | Dashboard';

  await protectRoute();
  await commonMiddleware();

  $('.editor-route').hide();
  $('#route-home').show();

  $('#navbar-private').hide();
  $('#navbar-canvas').hide();
  $('.logo').hide();

  $('body').addClass('dashboard');
  resetProfileMenuState();
  initHomeExperience();
  // Reinitialize profile after the route is visible so scoped selectors populate
  initSidebarProfile();
};
